import Immutable from 'immutable';
import jwtDecode from 'jwt-decode';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { currentUserFetch } from '../../actions/currentUserActions';
import { sessionDestroy } from '../../actions/sessionActions';

const enhance = function enhance(Component) {
  class RequireUser extends React.Component {
    static propTypes = {
      currentUser: PropTypes.instanceOf(Immutable.Map),
      routing:     PropTypes.instanceOf(Immutable.Map),
      token:       PropTypes.instanceOf(Immutable.Map)
    };

    componentDidMount() {
      this._checkAuthentication();
    }

    render() {
      const { currentUser, routing, token, ...rest } = this.props;

      return <Component { ...rest } />;
    }

    // private

    _checkAuthentication() {
      const token = this.props.token.getIn(['data', 'token']);
      const location = (this.props.routing || Immutable.Map()).get('locationBeforeTransitions') || {};
      const pathname = location.pathname;

      if (this._isTokenValid(token)) {
        this._fetchCurrentUser();
      } else if (pathname !== '/managers/new' && !pathname.match('\/reps\/new')) {
        this.props.dispatch(sessionDestroy());
      }
    }

    _fetchCurrentUser() {
      this.props.dispatch(currentUserFetch());
    }

    _isTokenValid(token) {
      if (token) {
        const claims = jwtDecode(token);

        return claims.exp > Math.round(Date.now() / 1000);
      }

      return false;
    }
  }

  return connect(mapStateToProps)(RequireUser);
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    routing:     state.get('routing'),
    token:       state.get('token')
  };
};

export default function requireUser() {
  return (Component) => enhance(Component);
}



// WEBPACK FOOTER //
// ./app/components/shared/requireUser.jsx